module.exports = __webpack_public_path__ + "img/Card_heart_6.1786928e.svg";